// Una stampante espone una sola porta seriale: due job bitmap non possono
// alternare i loro chunk sullo stesso socket Bluetooth. La coda e' per
// transport+indirizzo, cosi' un errore di un job non blocca quelli successivi.
const tails = new Map<string, Promise<void>>();

export function serializePrinterWrite<T>(
  printerKey: string,
  write: () => Promise<T>,
): Promise<T> {
  const previous = tails.get(printerKey) ?? Promise.resolve();
  const task = previous.catch(() => undefined).then(write);
  const settled = task.then(
    () => undefined,
    () => undefined,
  );
  tails.set(printerKey, settled);
  void settled.finally(() => {
    if (tails.get(printerKey) === settled) tails.delete(printerKey);
  });
  return task;
}
